var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fair-pay-detail-view"},[_c(_setup.PayRangeDetailPage,{attrs:{"pay-range-id":_setup.resolvedId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }